"use client"
import React, {useEffect} from "react";
export default function Home() {
  useEffect(() => {
    window.location.href = "/v2/tasks";
  }, []);
  return <h1>Root Page of Service OS frontend V2</h1>;
}
